import React from 'react';

const FinalReview = ({ answers }) => {
  return (
    <div className="text-center">
      <h2 className="text-2xl font-bold mb-8 text-gray-800">مرور اطلاعات</h2>
      <div className="space-y-6 text-right">
        <div>
          <h3 className="text-lg font-semibold text-gray-700">اطلاعات شخصی:</h3>
          <div className="space-y-2">
            <p className="text-gray-600">نام: {answers.fullName}</p>
            <p className="text-gray-600">سن: {answers.age} سال</p>
            <p className="text-gray-600">جنسیت: {answers.gender}</p>
            <p className="text-gray-600">شهر: {answers.city}</p>
            <p className="text-gray-600">شغل: {answers.job}</p>

          </div>
        </div>
        
        <div>
          <h3 className="text-lg font-semibold text-gray-700">نوع پوست:</h3>
          <p className="text-gray-600">{answers.skinType}</p>
        </div>
        
        <div>
          <h3 className="text-lg font-semibold text-gray-700">رنگ پوست:</h3>
          <p className="text-gray-600">{answers.skinTone}</p>
        </div>
        
        <div>
          <h3 className="text-lg font-semibold text-gray-700">مشکلات پوستی:</h3>
          <div className="flex flex-wrap gap-2 justify-end">
            {answers.concerns.map((concern) => (
              <span
                key={concern}
                className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-sm"
              >
                {concern}
              </span>
            ))}
          </div>
        </div>
        
        <div>
          <h3 className="text-lg font-semibold text-gray-700">سبک زندگی:</h3>
          <div className="space-y-2">
            <p className="text-gray-600">ورزش: {answers.lifestyle.exercise}</p>
            <p className="text-gray-600">سیگار: {answers.lifestyle.smoking}</p>
            <p className="text-gray-600">استرس: {answers.lifestyle.stress}</p>
            <p className="text-gray-600">خواب: {answers.lifestyle.sleep}</p>
            <p className="text-gray-600">متخصص پوست: {answers.lifestyle.doctor}</p>
            <p className="text-gray-600">رژیم غذایی: {answers.lifestyle.diet}</p>
          </div>
        </div>
        
        <div>
          <h3 className="text-lg font-semibold text-gray-700">برندهای شناخته شده:</h3>
          <div className="space-y-4">
            <div>
              <h4 className="text-md font-medium text-gray-700 mb-2">🇮🇷 برندهای ایرانی:</h4>
              <div className="flex flex-wrap gap-2 justify-end">
                {answers.knownBrands?.iranian?.length > 0 ? (
                  answers.knownBrands.iranian.map((brand) => (
                    <span
                      key={brand}
                      className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-sm"
                    >
                      {brand}
                    </span>
                  ))
                ) : (
                  <p className="text-gray-500 text-sm">هیچ برندی انتخاب نشده</p>
                )}
              </div>
            </div>
            
            <div>
              <h4 className="text-md font-medium text-gray-700 mb-2">🌍 برندهای خارجی:</h4>
              <div className="flex flex-wrap gap-2 justify-end">
                {answers.knownBrands?.international?.length > 0 ? (
                  answers.knownBrands.international.map((brand) => (
                    <span
                      key={brand}
                      className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-sm"
                    >
                      {brand}
                    </span>
                  ))
                ) : (
                  <p className="text-gray-500 text-sm">هیچ برندی انتخاب نشده</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinalReview; 